// src/components/FeatureChips.js

import React from 'react';
import { Box } from '@mui/material';
import Chip from '@mui/material/Chip';
import StarIcon from '@mui/icons-material/Star';
import PropTypes from 'prop-types';

const FeatureChips = ({ features }) => {
    return (
        <Box my={2}>
            {features.map((feature, index) => (
                <Chip
                    key={index}
                    icon={feature.icon || <StarIcon />}
                    label={feature.label}
                    sx={{ margin: 0.5 }}
                />
            ))}
        </Box>
    );
};

FeatureChips.propTypes = {
    features: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.element,
        })
    ).isRequired,
};

export default FeatureChips;
